import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { toAxiosError } from '@issuemanager/apps/client/utils';
import { useMutation, UseMutationResult } from '@tanstack/react-query';

export function useUploadAttachment(): UseMutationResult<
  undefined,
  ExtendedAxiosError,
  { url: string; attachment: File }
> {
  return useMutation<
    undefined,
    ExtendedAxiosError,
    { url: string; attachment: File }
  >({
    mutationKey: ['highbond-drive', 'upload'],
    meta: {
      handleError: true,
    },
    mutationFn: async ({ url, attachment }) => {
      const urlObj = new URL(url);
      const domain = urlObj.hostname;
      const tld = domain.split('.').pop();

      if (tld === 'test') {
        const fakeUpload = new Promise<undefined>((resolve) => {
          setTimeout(() => {
            resolve(undefined);
          }, 1000);
        });
        return fakeUpload;
      }

      // Use native fetch instead of axios to avoid interceptor issues with S3
      const response = await fetch(url, {
        method: 'PUT',
        body: attachment,
        headers: {
          'Content-Type': attachment.type,
        },
      });

      if (!response.ok) {
        // S3 returns XML string, not ResponseErrorData
        const responseData = await response.text();
        throw toAxiosError(response.status, response.statusText, responseData);
      }

      return undefined;
    },
  });
}
